module.exports = __webpack_public_path__ + "media/src/assets/Images/AppSectionRectangle-d8238a44108e687e8d26b7876f2db44e.svg";